import {
    GET_ALL_QUALIFICATIONS,
    GET_QUALIFICATION_CATEGORIES,
    SET_TABLE,
    SET_PAGE_INDEX,
    SET_ROW_COUNT,
    SET_CATEGORY,
    ADD_QUALIFICATION,
    REMOVE_QUALIFICATION,
    GET_USERS,
    SET_SNACKBAR_STATE,
    GET_CUSTOM_QUALIFICATONS,
    CREATE_CUSTOM_QUALIFICATION,
    EDIT_CUSTOM_QUALIFICATION,
    SET_VIEW_VALID_USERS_MODAL_INFO,
    GET_DEPARTMENTS, GET_AREAS,
} from "./types";
import firebase from "firebase/app";
import _ from "lodash";
import customQualifictionImgs from "./customQualificationImgs";
export const getAllQualifications = () => {
    return dispatch => {
        dispatch({ type: GET_ALL_QUALIFICATIONS.REQUEST });

        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                firebase
                    .database()
                    .ref(`collections/qualifications`)
                    .on(
                        "value",
                        snapshot => {
                            dispatch({
                                type: GET_ALL_QUALIFICATIONS.SUCCESS,
                                payload: snapshot.val()
                            });
                        },
                        () => dispatch({ type: GET_ALL_QUALIFICATIONS.FAIL })
                    );
            } else {
                dispatch({ type: GET_ALL_QUALIFICATIONS.FAIL });
            }
        });
    };
};

export const getQualificationCategories = () => {
    return dispatch => {
        dispatch({ type: GET_QUALIFICATION_CATEGORIES.REQUEST });

        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                firebase
                    .database()
                    .ref(`collections/qualification_categories`)
                    .on(
                        "value",
                        snapshot => {
                            dispatch({
                                type: GET_QUALIFICATION_CATEGORIES.SUCCESS,
                                payload: snapshot.val()
                            });
                        },
                        () => {
                            dispatch({ type: GET_ALL_QUALIFICATIONS.FAIL });
                        }
                    );
            } else {
                dispatch({ type: GET_QUALIFICATION_CATEGORIES.FAIL });
            }
        });
    };
};
export const setCurrentTable = (table = "required") => {
    return dispatch => {
        dispatch({ type: SET_TABLE, payload: table });
    };
};

export const setPageIndex = (page = 0) => {
    return dispatch => {
        dispatch({ type: SET_PAGE_INDEX, payload: page });
    };
};

export const setRowCount = (rowCount = 50) => {
    return dispatch => {
        dispatch({ type: SET_ROW_COUNT, payload: rowCount });
    };
};

export const setCategory = (category = "all_categories") => {
    return dispatch => {
        dispatch({ type: SET_CATEGORY, payload: category });
    };
};

export const addQualification = (qualification = false) => {
    return (dispatch, getStore) => {
        let store = getStore();
        dispatch({ type: ADD_QUALIFICATION.REQUEST });
        if (qualification) {
            firebase.auth().onAuthStateChanged(async user => {
                if (user) {
                    try {
                        await updateQualification(qualification, true);
                        await addQualificationToRequiredQualifications(
                            qualification
                        );
                        await addQualificationToUserProfiles(
                            qualification,
                            store
                        );
                        dispatch({ type: ADD_QUALIFICATION.SUCCESS });
                    } catch {
                        dispatch({ type: ADD_QUALIFICATION.FAIL });
                    }
                } else {
                    dispatch({ type: ADD_QUALIFICATION.FAIL });
                }
            });
        } else {
            dispatch({ type: ADD_QUALIFICATION.FAIL });
        }
    };
};

const updateQualification = (qualification, selected) => {
    firebase
        .database()
        .ref(`/collections/qualifications/${qualification.qualification_id}`)
        .update({ ...qualification, qualification_selected: selected });
};
const addQualificationToRequiredQualifications = qualification => {
    firebase
        .database()
        .ref(`collections/required_qualifications`)
        .update({
            [qualification.qualification_id]: {
                ...qualification,
                qualification_selected: true
            }
        });
};
const addQualificationToUserProfiles = (qualification, store) => {
    let users = store.QualificationsManagerV2_reducer.users;
    let newQualification = {
        qualification_category: qualification.qualification_category,
        qualification_desc: qualification.qualification_desc,
        qualification_exp_date: "Req.",
        qualification_id: qualification.qualification_id,
        qualification_invalid_img: qualification.qualification_invalid_img,
        qualification_prefix: qualification.qualification_prefix,
        qualification_reg_num: "",
        qualification_title: qualification.qualification_title,
        qualification_valid_img: qualification.qualification_valid_img,
        qualification_verified: "No",
        qualification_img: "",
        qualification_img_2: ""
    };
    if (users) {
        let validUserUids = getValidUserUids(users);
        const usersUpdate = {};
        validUserUids.map(uid => {
            usersUpdate[
                `${uid}/profile/qualifications_per_user/${
                    qualification.qualification_id
                }`
            ] = newQualification;
            return true;
        });

        firebase
            .database()
            .ref("/users")
            .update(usersUpdate);
        return true;
    } else throw new Error("No users in store");
};

const getValidUserUids = users => {
    return _.compact(
        Object.keys(users).map(uid => {
            let deleted = _.get(users[uid], "profile.deleted") || false;
            let type = _.get(users[(uid, "profile.type")]) || "person";
            if (!deleted && type === "person") {
                return uid;
            } else return null;
        })
    );
};
export const removeQualification = (qualification = false) => {
    return (dispatch, getStore) => {
        dispatch({ type: REMOVE_QUALIFICATION.REQUEST });
        if (qualification) {
            firebase.auth().onAuthStateChanged(async user => {
                if (user) {
                    try {
                        await updateQualification(qualification, false);
                        await removeQualificationFromRequiredQualifications(
                            qualification
                        );
                        await removeQualificationFromUserProfiles(
                            qualification,
                            getStore()
                        );
                    } catch {
                        dispatch({ type: REMOVE_QUALIFICATION.FAIL });
                    }
                } else {
                    dispatch({ type: REMOVE_QUALIFICATION.FAIL });
                }
            });
        } else dispatch({ type: REMOVE_QUALIFICATION.FAIL });
    };
};

const removeQualificationFromRequiredQualifications = qualification => {
    firebase
        .database()
        .ref(`collections/required_qualifications/`)
        .child(qualification.qualification_id)
        .remove();
};

const removeQualificationFromUserProfiles = (qualification, store) => {
    let users = store.QualificationsManagerV2_reducer.users;

    if (users) {
        let validUserUids = getValidUserUids(users);
        const usersUpdate = {};
        validUserUids.map(uid => {
            usersUpdate[
                `${uid}/profile/qualifications_per_user/${
                    qualification.qualification_id
                }`
            ] = null;
            return true;
        });
        firebase
            .database()
            .ref("/users")
            .update(usersUpdate);
        return true;
    } else throw new Error("No Users");
};

export const getUsers = () => {
    return dispatch => {
        dispatch({ type: GET_USERS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`users`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_USERS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ tuype: GET_USERS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_USERS.FAIL });
        }
    };
};

export const setSnackbarState = (state = false) => {
    return dispatch => {
        dispatch({ type: SET_SNACKBAR_STATE, payload: state });
    };
};

export const getCustomQualifications = () => {
    return dispatch => {
        dispatch({ type: GET_CUSTOM_QUALIFICATONS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`collections/custom_qualifications`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_CUSTOM_QUALIFICATONS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_CUSTOM_QUALIFICATONS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_CUSTOM_QUALIFICATONS.FAIL });
        }
    };
};

export const createCustomQualification = (
    qualificationID = false,
    qualificationTitle = false
) => {
    return dispatch => {
        dispatch({ type: CREATE_CUSTOM_QUALIFICATION.REQUEST });
        if (qualificationID && qualificationTitle) {
            let prefix = qualificationTitle.split(" ")[1];
            let imgs = customQualifictionImgs[prefix];
            let newQualification = {
                qualification_category: "Custom Qualifications",
                qualification_desc: "",
                qualification_expiry_date_required: true,
                qualification_id: qualificationID,
                qualification_image_required: true,
                qualification_invalid_img: imgs.invalid_img,
                qualification_prefix: "",
                qualification_reg_number_required: true,
                qualification_selected: false,
                qualification_title: qualificationTitle,
                qualification_valid_img: imgs.valid_img,
                qualification_verification_required: true
            };
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user) {
                        Promise.all([
                            firebase
                                .database()
                                .ref(`collections/qualifications`)
                                .update({
                                    [qualificationID]: newQualification
                                }),
                            firebase
                                .database()
                                .ref(`collections/custom_qualifications`)
                                .update({ [qualificationID]: newQualification })
                        ])
                            .then(() =>
                                dispatch({
                                    type: CREATE_CUSTOM_QUALIFICATION.SUCCESS
                                })
                            )
                            .catch(() =>
                                dispatch({
                                    type: CREATE_CUSTOM_QUALIFICATION.FAIL
                                })
                            );
                    } else {
                    }
                });
            } catch {
                dispatch({ type: CREATE_CUSTOM_QUALIFICATION.FAIL });
            }
        } else {
            dispatch({ type: CREATE_CUSTOM_QUALIFICATION.FAIL });
        }
    };
};
export const editCustomQualification = (qualification = false) => {
    return dispatch => {
        dispatch({ type: EDIT_CUSTOM_QUALIFICATION.REQUEST });

        if (qualification) {
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user) {
                        Promise.all([
                            firebase
                                .database()
                                .ref(`/collections/qualifications/`)
                                .update({
                                    [qualification.qualification_id]: qualification
                                }),
                            firebase
                                .database()
                                .ref(`/collections/custom_qualifications/`)
                                .update({
                                    [qualification.qualification_id]: qualification
                                })
                        ])
                            .then(() =>
                                dispatch({
                                    type: EDIT_CUSTOM_QUALIFICATION.SUCCESS
                                })
                            )
                            .catch(() => EDIT_CUSTOM_QUALIFICATION.FAIL);
                    } else {
                        dispatch({ type: EDIT_CUSTOM_QUALIFICATION.FAIL });
                    }
                });
            } catch {
                dispatch({ type: CREATE_CUSTOM_QUALIFICATION.FAIL });
            }
        } else {
            dispatch({ type: EDIT_CUSTOM_QUALIFICATION.FAIL });
        }
    };
};
export const setViewValidUsersModalInfo = (
    state = false,
    qualification_id = false
) => {
    return dispatch => {
        dispatch({
            type: SET_VIEW_VALID_USERS_MODAL_INFO,
            payload: { state, qualification_id }
        });
    };
};
export const getDepartments = () => {
    return dispatch => {
        dispatch({ type: GET_DEPARTMENTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_DEPARTMENTS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/departments")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_DEPARTMENTS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_DEPARTMENTS.FAIL });
        }
    };
};
export const getAreas = () => {
    return dispatch => {
        dispatch({ type: GET_AREAS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_AREAS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/areas")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_AREAS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_AREAS.FAIL });
        }
    };
};